import classNames from "classnames";
import React, { useState, ReactNode } from "react";
import { Tab } from "@headlessui/react";

export type CaTab = {
  label: (selected: boolean) => ReactNode;
  children: ReactNode;
  disabled?: boolean;
};

export type CaTabsProps = {
  tabs: CaTab[];
  className?: string;
  listWrapper?: (children: ReactNode) => ReactNode;
};

function CaTabs({ tabs, className, listWrapper }: CaTabsProps) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const headers = (
    <Tab.List className='flex gap-5 font-sans-serif'>
      {tabs.map((tab, index) => (
        <Tab
          key={index}
          className={({ selected }) =>
            classNames(
              "flex items-center px-4 py-2 text-base font-normal focus:outline-none focus-visible:outline-none",
              selected
                ? "text-purple font-semibold border-b-2 border-purple"
                : "text-dark-neutral-",
              tab.disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer",
            )
          }
          disabled={tab.disabled}
        >
          {tab.label(index === selectedIndex)}
        </Tab>
      ))}
    </Tab.List>
  );

  return (
    <div className={classNames(className)}>
      <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
        {listWrapper ? listWrapper(headers) : headers}
        <Tab.Panels className='mt-7'>
          {tabs.map((tab, index) => (
            <Tab.Panel key={index} className=''>
              {tab.children}
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
}

export default CaTabs;
